let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("amwIY")).then(() => parcelRequire('QQ1JK'));